import { io } from "socket.io-client";
import {APIService} from '../store/modules/rest-api-module';

function SocketContainer () {

  // member data
  this.socket = {}
  this.socketServer = ''

  // member functions
  this.initialize = function () {
    this.socketServer = 'not connected'
  }

  this.ID = function () {
    if(this.socket){
      return this.socket.id
    }
    else
    {
      return null
    }
  }

  this.connect = function (server) {
    console.log('Creating a socket connection to: ', server)
    let portIndex = server.lastIndexOf(":");
    let portNumber = server.slice(portIndex - server.length + 1)
    this.socketServer = server.replace(portNumber, "3001")
    this.socket = io(this.socketServer)
    let mySocket = this.socket
    this.socket.on('connect', () => { APIService.setSocketID(mySocket.id) })
  }

  this.addEventListener = function ({eventName, eventReaction}) {
    this.socket.on(eventName, eventReaction)
  }
}

export default SocketContainer
